import { IntegrationKey } from '../../pages/integrations/shared/models';
import type { AreasDiffResponse, JDOCAreasDiffResponse, PerfectFlightAreaDiff } from '@protector/entities/integration/models';

export function mapResponseToAreaDiffResponse(
  response: (JDOCAreasDiffResponse | PerfectFlightAreaDiff)[],
  type: IntegrationKey
): AreasDiffResponse[] {
  return response.map<AreasDiffResponse>(r => {
    return {
      atlas_area: r.atlas_area,
      intersection_percentage: r.intersection_percentage,
      integration_area:
        type === IntegrationKey.JOHN_DEERE ? (r as JDOCAreasDiffResponse).john_deere_area : (r as PerfectFlightAreaDiff).perfect_flight_area
    };
  });
}
